import _ from 'lodash';

import View from '../_components/view/view.js';
import normativeSectionTpl from './normative-section.tpl.html';
import './normative-section.styles.less';

class NormativeSectionView extends View {

	constructor (data, options) {
		super(normativeSectionTpl, data, options);
	}

	/*uiElements() {
		return _.extend(super.uiElements(), {
		});
	}*/

	render(data) {
		super.render(data);

	}

	initializeEvents() {

	}

	/*onShow() {

	}*/


}

export default NormativeSectionView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/normative-section/normative-section.view.js